import { render, staticRenderFns } from "./ViewModels.vue?vue&type=template&id=86c10254&scoped=true&"
import script from "./ViewModels.vue?vue&type=script&lang=js&"
export * from "./ViewModels.vue?vue&type=script&lang=js&"
import style0 from "./ViewModels.vue?vue&type=style&index=0&id=86c10254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c10254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VSpacer})
